export interface Params {
  id?: string;
  type?: string;
}

export enum ApplicationType {
  AI_AGENT = "AI_AGENT",
  APPLICATION = "APPLICATION",
}

export enum DATA_TYPE {
  STRING = "STRING",
  BOOLEAN = "BOOLEAN",
  NUMBER = "NUMBER",
  ENUM = "ENUM",
  DATE = "DATE",
}

export interface IdName {
  id?: string;
  name?: string;
}
